var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 29,
    viewBox: "0 0 326 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L34.4355 25.3729L68.871 0L69.0678 69.6078H0.196774L0 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.653 0V69.6078H78.7373V0H114.653Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.583 0C164.966 0 168.917 0.977825 172.437 2.93347C175.957 4.88912 178.713 7.44141 180.706 10.5903C182.698 13.7393 183.694 17.0373 183.694 20.4846C183.694 24.9925 182.133 28.937 179.012 32.3179C181.536 34.1741 183.412 36.3452 184.64 38.8312C185.869 41.3172 186.483 43.9524 186.483 46.7367C186.483 50.5154 185.371 54.1615 183.146 57.6751C180.921 61.1886 177.75 64.0558 173.633 66.2766C169.515 68.4974 164.8 69.6078 159.487 69.6078H124.322V0H160.583Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.089 1.39209L262.458 69.6078H183.721L223.089 1.39209Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.467 1.39209C297.701 1.39209 303.472 2.94722 308.78 6.05749C314.088 9.16776 318.285 13.3977 321.371 18.7474C324.457 24.0971 326 29.9133 326 36.196C326 42.4788 324.457 48.295 321.371 53.6446C318.285 58.9943 314.088 63.2243 308.78 66.3345C303.472 69.4448 297.701 70.9999 291.467 70.9999C285.233 70.9999 279.461 69.4448 274.153 66.3345C268.845 63.2243 264.648 58.9943 261.562 53.6446C258.476 48.295 256.933 42.4788 256.933 36.196C256.933 29.9133 258.476 24.0971 261.562 18.7474C264.648 13.3977 268.845 9.16776 274.153 6.05749C279.461 2.94722 285.233 1.39209 291.467 1.39209Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full-logo.07e53f69.svg";
export { ForwardRef as ReactComponent };